module.exports = __webpack_public_path__ + "media/country_flags/ck-7a2f3dc8.png";